<div
  #container
  [class]="`filter-button filter-button--${alignment()}`"
  [id]="id"
>
  <procure-button-group>
    <button
      class="filter-button__toggle"
      procure-button
      filter
      wide
      suffix="arrow_drop_down"
      variant="flat"
      [matTooltip]="tooltip() ? tooltipValue() : ''"
      [disabled]="items()?.length === 0"
      [color]="control().value.length ? activeColor() : 'grey'"
      (click)="toggleOverlay()"
    >
      <span class="filter-button__label">
        @if (firstValue(); as firstValue) {
          <span>
            <b>{{ label() }}</b
            >: {{ getDisplay(firstValue) }}
          </span>
        } @else {
          {{ label() }}
        }
      </span>
      @if (!tooltip()) {
        <span class="filter-button__remainder">
          @if (remainder(); as remainder) {
            (+ {{ remainder }})
          }
        </span>
      }
    </button>
    @if (firstValue()) {
      <button
        class="filter-button__clear"
        procure-button
        filter
        [color]="activeColor()"
        [variant]="control().value.length ? 'flat' : 'stroked'"
        (click)="reset()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    }
  </procure-button-group>
  @if (isOpened()) {
    <div
      #overlay
      class="filter-button__overlay mat-elevation-z8 overlay"
    >
      <div formRow>
        <button
          class="overlay__button"
          procure-button
          variant="stroked"
          (click)="selectAll()"
        >
          Select All
        </button>
        <button
          class="overlay__button"
          procure-button
          variant="stroked"
          (click)="reset()"
        >
          Reset
        </button>
      </div>
      <ng-content />
      <div formRow>
        <procure-input-search
          label="Search"
          [control]="searchControl"
        />
      </div>
      <div formRow>
        <div class="overlay__content">
          <procure-loading-indicator [active]="isLoading()" />
          <cdk-virtual-scroll-viewport
            #scrollViewport
            class="overlay__options"
            appendOnly
            [itemSize]="itemSize()"
          >
            <div
              *cdkVirtualFor="let item of disaplyedItems()"
              class="overlay__option"
            >
              <procure-checkbox
                condensed
                large
                [checked]="selectedIds() | contains: getId(item)"
                (valueChange)="toggleSelection($event, item)"
              >
                @if (isEntity(item)) {
                  <procure-entity-badge
                    [label]="item.entityNumber"
                    [copyNumber]="false"
                    [linked]="false"
                  />
                  {{ item.name }}
                } @else {
                  @if (isStatus(item)) {
                    <procure-status-badge [status]="item" />
                  } @else {
                    <div class="overlay__label">
                      @if (isUser(item)) {
                        <procure-avatar
                          [name]="item.name"
                          [avatar]="item.avatarUrl"
                        />
                      }
                      {{ getDisplay(item) }}
                    </div>
                  }
                }
              </procure-checkbox>
            </div>
          </cdk-virtual-scroll-viewport>
        </div>
      </div>
      <div formRow>
        <button
          class="overlay__button"
          procure-button
          variant="flat"
          (click)="toggleOverlay()"
        >
          Close
        </button>
      </div>
    </div>
  }
</div>
